function SectionTitle({ title, subtitle }: { title: string; subtitle?: string }) {
    return (
        <div className="section-title">
            <h2>{title}</h2>
            <span>{subtitle}</span>
        </div>
    );
}

export default SectionTitle;
